let Utils = {
  /**
   * 判断是否是空值
   * @param v
   * @returns {boolean}
   * @constructor
   */
  IsEmpty: function (v) {
    if (v == null || v === '') {
      return true
    }
    return false
  },
  IsNull: function (v) {
    if (v == null) {
      return true
    }
    return false
  },
  IsMobile: function (v) {
    var telReg = v.match(/^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/) // 如果手机号码不能通过验证
    return telReg
  },
  getWeekByInt: function (i) {
    switch (i) {
      case '0':
        return '周日'
      case '1':
        return '周一'
      case '2':
        return '周二'
      case '3':
        return '周三'
      case '4':
        return '周四'
      case '5':
        return '周五'
      case '6':
        return '周六'
      default:
        return ''
    }
  },

  /**
   * 时间格式化
   * @param date
   * @param format
   */
  dateFormat: function (date, fmt) {
    if (Utils.IsEmpty(fmt)) {
      fmt = 'yyyy-MM-dd HH:mm:ss'
    }
    let o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'H+': date.getHours(), // 24小时
      'h': date.getHours() > 12 ? date.getHours() - 12 : date.getHours(), // 12小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds()
      // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },

  /**
   * 将jsonObjB 复制到 jsonObjA
   * @param jsonObjA
   * @param jsonObjB
   */
  copyJsonObject: function (jsonObjA, jsonObjB) {
    for (let key in jsonObjB) {
      jsonObjA[key] = jsonObjB[key]
    }
  }
}

export {
  Utils
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js